import { api } from "./api";

export const loginApi = (params) => {
  return api.post("/distributor/auth/login", JSON.stringify(params));
};

export const signupApi = (params) => {
  return api.post("/distributor/auth/sign-up", JSON.stringify(params));
};

export const verifyEmail = (params) => {
  return api.post("/distributor/auth/verify-email", JSON.stringify(params));
};

export const forgetPasswordApi = (params) => {
  return api.post("/distributor/auth/forgot-password", JSON.stringify(params));
};

export const resetPasswordApi = (params) => {
  return api.post("/distributor/auth/reset-password", JSON.stringify(params));
};

export const logoutApi = (params) => {
  return api.delete("/distributor/auth/logout", JSON.stringify(params));
};


export const portalLoginApi = (params) => {
  return api.post("/distributor/auth/portal-login", JSON.stringify(params));
};

export const distributerProfileApi = (params) => {
  return api.get(`/distributor/profile/my-profile`, { params: params })
}

export const distributerProfileEditApi = (params) => {
  return api.post(`distributor/profile/edit-distributor-contact-details`, JSON.stringify(params))
}

export const DistributerLogoUploadApi = (params) => {
  return api.post(`/distributor/profile/upload-logo`, params, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export const createNewPasswordApi = (params) => {
  return api.post(`distributor/auth/create-new-password`, JSON.stringify(params))
}